
// src/connects/diary-attachments.js

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { translate } from 'react-i18next'
import ui from '../helpers/ui-state'
import _ from 'lodash'

function isImageVideo(file) {
  return file.content_type.match(/^image/) || file.content_type.match(/^video|audio/) 
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willUpdate: (props, nextProps)=> {
      //添付ファイルの中に変動があった場合、処理を行う
      if(props.files.length != nextProps.files.length){
        const imageVideos = _.filter(props.files, (file)=> isImageVideo(file))
        const nextImageVideos = _.filter(nextProps.files, (file)=> isImageVideo(file))
        //ui.imgindexの最後を閲覧した状態からそのファイルを削除した場合時に-1をしたものをimgIndexに渡す。
        if(nextImageVideos.length > 0 && imageVideos.length != nextImageVideos.length){
          nextProps.updateUI({ imgIndex: 0 })
        }
      }
    },
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps),
  ui({ 
    state: { 
      imgIndex: 0,
      isVideo: false,
    }
  }),
  lifecycle,
  translate(),
)


// WEBPACK FOOTER //
// ./src/connects/diary-attachments.js